if (window.Gift == null) {
  window.Gift = {};
}

Gift.init = function(payload, done) {
  return $(function() {
    Gift.bindGiftButton();
    return done();
  });
};

Gift.bindGiftButton = function() {
  var $gift_button;
  $gift_button = $('.gift-button');
  if ($gift_button.length > 0) {
    return $gift_button.on('click', function(e) {
      e.preventDefault();
      Gift.createCookie();
      BuyButton.view.giftButtonClicked = true;
      return BuyButton.eventBus.go('buy_button_clicked');
    });
  }
};

Gift.createCookie = function() {
  var cookieDomain, ref;
  cookieDomain = typeof payload !== "undefined" && payload !== null ? (ref = payload.giftButton) != null ? ref.cookieDomain : void 0 : void 0;
  Cookie.set('modalForGiftOnLoad', 'true', 60, cookieDomain);
  return Gift.cookieCreated = true;
};

Gift.removeCookie = function() {
  var cookieDomain, ref;
  cookieDomain = typeof payload !== "undefined" && payload !== null ? (ref = payload.giftButton) != null ? ref.cookieDomain : void 0 : void 0;
  Cookie.unset('modalForGiftOnLoad', cookieDomain);
  return Gift.cookieCreated = false;
};

module.exports = Gift;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9naWZ0X2J1dHRvbi9mcm9udGVuZC9naWZ0LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvZ2lmdF9idXR0b24vZnJvbnRlbmQvZ2lmdC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtFQUFBLE1BQU0sQ0FBQyxPQUFROzs7QUFFZixJQUFJLENBQUMsSUFBTCxHQUFZLFNBQUMsT0FBRCxFQUFVLElBQVY7U0FDVixDQUFBLENBQUUsU0FBQTtJQUNBLElBQUksQ0FBQyxjQUFMLENBQUE7V0FDQSxJQUFBLENBQUE7RUFGQSxDQUFGO0FBRFU7O0FBS1osSUFBSSxDQUFDLGNBQUwsR0FBc0IsU0FBQTtBQUNwQixNQUFBO0VBQUEsWUFBQSxHQUFnQixDQUFBLENBQUUsY0FBRjtFQUVoQixJQUFHLFlBQVksQ0FBQyxNQUFiLEdBQXNCLENBQXpCO1dBQ0UsWUFBWSxDQUFDLEVBQWIsQ0FBZ0IsT0FBaEIsRUFBeUIsU0FBQyxDQUFEO01BQ3ZCLENBQUMsQ0FBQyxjQUFGLENBQUE7TUFDQSxJQUFJLENBQUMsWUFBTCxDQUFBO01BRUEsU0FBUyxDQUFDLElBQUksQ0FBQyxpQkFBZixHQUFtQzthQUNuQyxTQUFTLENBQUMsUUFBUSxDQUFDLEVBQW5CLENBQXNCLG9CQUF0QjtJQUx1QixDQUF6QixFQURGOztBQUhvQjs7QUFZdEIsSUFBSSxDQUFDLFlBQUwsR0FBb0IsU0FBQTtBQUNsQixNQUFBO0VBQUEsWUFBQSxnR0FBa0MsQ0FBRTtFQUNwQyxNQUFNLENBQUMsR0FBUCxDQUFXLG9CQUFYLEVBQWdDLE1BQWhDLEVBQXVDLEVBQXZDLEVBQTJDLFlBQTNDO1NBQ0EsSUFBSSxDQUFDLGFBQUwsR0FBcUI7QUFISDs7QUFLcEIsSUFBSSxDQUFDLFlBQUwsR0FBb0IsU0FBQTtBQUNsQixNQUFBO0VBQUEsWUFBQSxnR0FBa0MsQ0FBRTtFQUNwQyxNQUFNLENBQUMsS0FBUCxDQUFhLG9CQUFiLEVBQW1DLFlBQW5DO1NBQ0EsSUFBSSxDQUFDLGFBQUwsR0FBcUI7QUFISDs7QUFNcEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
